// Display labels for coded enum values on the assessment form (QA #5). The stored value stays
// the code; only what the user reads changes.
const ENUM_LABELS: Record<string, string> = { SMPL: 'Simple', MODR: 'Moderate', CMPL: 'Complex' };

export const enumOptionLabel = (v: unknown): string => ENUM_LABELS[String(v)] ?? String(v);
